var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrownDecore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 212,
    viewBox: "0 0 203 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.7995 151.371C88.3161 178.762 122.58 163.126 139.76 159.805C123.994 150.487 99.8302 133.647 84.257 151.266",
    fill: "#633235"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8788 166.025C72.3167 154.482 94.9463 143.679 113.898 156.342C114.828 156.936 113.861 158.333 112.935 157.742C94.5956 145.536 72.8814 156.283 56.9952 167.323C56.8225 167.46 56.6027 167.524 56.3823 167.503C56.1618 167.481 55.9578 167.375 55.8133 167.207C55.6687 167.039 55.595 166.822 55.6074 166.601C55.6199 166.381 55.7176 166.175 55.8801 166.026L55.8788 166.025Z",
    fill: "#3F3D56",
    fillOpacity: 0.44
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3543 166.954C64.7594 184.929 91.9191 191.056 103.514 196.762C98.4044 184.318 91.7129 163.755 74.6707 167.098",
    fill: "#633235"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8797 165.076C64.8 165.745 83.0542 169.414 88.557 185.424C88.9404 186.451 87.3006 186.915 86.9179 185.889C81.5637 170.742 64.1159 167.401 49.9194 166.779C48.8336 166.694 48.7814 164.99 49.8797 165.076Z",
    fill: "#3F3D56",
    fillOpacity: 0.44
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4884 38.6772C67.3619 86.4262 127.091 59.1687 157.039 53.3789C129.555 37.1362 87.4333 7.78128 60.2861 38.4945",
    fill: "#633235"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3645 63.5023C41.019 43.3789 80.4669 24.5484 113.503 46.6228C115.124 47.6571 113.439 50.0927 111.825 49.0617C79.8554 27.7844 42.0034 46.5189 14.3106 65.7637C14.0095 66.0028 13.6264 66.1154 13.242 66.0778C12.8576 66.0402 12.5018 65.8552 12.2498 65.562C11.9977 65.2688 11.8692 64.8903 11.8909 64.5061C11.9127 64.1218 12.0833 63.762 12.3667 63.5023L12.3645 63.5023Z",
    fill: "#3F3D56",
    fillOpacity: 0.44
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0198 65.8432C26.294 97.1777 73.6387 107.858 93.8516 117.805C84.944 96.1135 73.2795 60.2681 43.5714 66.095",
    fill: "#633235"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89465 61.8511C27.9037 63.0179 59.7244 69.4143 69.3168 97.3213C69.9851 99.1128 67.1266 99.9209 66.4594 98.1325C57.126 71.7278 26.7111 65.9048 1.96377 64.8201C0.0711568 64.6722 -0.019956 61.7022 1.89465 61.8511Z",
    fill: "#3F3D56",
    fillOpacity: 0.44
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrownDecore);
export default __webpack_public_path__ + "static/media/brown-decore.e31fde171bcfe99d08448c33d683f1d5.svg";
export { ForwardRef as ReactComponent };